import Form from '@components/form/Form';
import Description from '@components/typography/Description';
import Modal from './Modal';

const ConfirmModal: React.FC<ConfirmModalProps> = ({
    closeModal,
    handleSubmit,
    isPosting,
    title = 'Confirm',
    description = 'Are you sure?',
    submitButtonColor = 'green',
}) => {
    return (
        <Modal closeModal={closeModal} title={title} size="small">
            <Description>{description}</Description>
            <Form
                submitButtonColor={submitButtonColor}
                onSubmit={handleSubmit}
                onCancel={closeModal}
                isPosting={isPosting}
            />
        </Modal>
    );
};
interface ConfirmModalProps {
    closeModal: () => void;
    handleSubmit: () => void;
    isPosting?: boolean;
    title?: string;
    description?: string;
    submitButtonColor?: string;
}

export default ConfirmModal;
